import { useCheckoutConfigurations } from "./useCheckoutConfigurations";
import { useValidateCheckoutForm } from "./useValidateCheckout";

export const useManageCheckoutConfigurations = () => {
  const { checkoutConfigurations } = useCheckoutConfigurations();

  const [{ error: validationError, isPending }, validateCheckoutForm] =
    useValidateCheckoutForm();

  return {
    checkoutConfigurations,
    validateCheckoutForm,
    validationError,
    isPending,
  };
};
